import styled from 'styled-components';

export const CardWrapper = styled('div')`
  ${({ theme }) => `
    width: 100%;
    max-width: ${theme.spacing.full};
    box-sizing: border-box;
    @media screen and (max-width: ${theme.breakpoint.sm}) {
      background:transparent;
      box-shadow:none;
      margin-left: auto;
      margin-right: auto;
    }
  `}
`;

export const ButtonWrapper = styled('div')`
  ${({ theme }) => `
    display: flex;
    justify-content: center;
    align-self:center;
    margin-left:auto;
    margin-right:auto;
    margin-top:50px;
    @media screen and (max-width: ${theme.breakpoint.sm}) {
      flex-direction: column;
      justify-content: center;
      flex-wrap: wrap;

      margin-top: 116px;
    }
    & > button  {
      width:260px;
      height:56px;
      margin-left:auto!important;
      margin-right:auto!important;
    }
  `}
`;

export const TextDescriptionWrapper = styled('div')`
  ${({ theme }) => `
    align-items: center;
    justify-content: center;
    text-align:center;
    margin-top:24px;
    color:#707070;
    font-size:16px;
    margin-left: auto;
    margin-right: auto;
    @media screen and (max-width: ${theme.breakpoint.sm}) {
      margin-top:16px;
      width: 155px;
      font-size:14px;
    }
  `}
`;

export const TextBoldWrapper = styled('div')`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    margin-bottom:20px;
    justify-content: center;
    font-weight:bold;
    font-size:24px;
    color: '#0C2833';
    margin-top:50px;
    margin-left: auto;
    margin-right: auto;
    @media screen and (max-width: ${theme.breakpoint.sm}) {
      text-align:center;
      width: 250px;
      margin-top:50px;
    }
  `}
`;

export const TextBoldWrapperSet = styled('div')`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    margin-bottom:20px;
    justify-content: center;
    font-weight:bold;
    font-size:24px;
    color: '#0C2833';
    margin-left: auto;
    margin-right: auto;
    @media screen and (max-width: ${theme.breakpoint.sm}) {
      text-align:center;
      width: 250px;
    }
  `}
`;

export const PageListWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  overflow: auto;
  justify-content: center;
  align-items: center;
  align-content: center;
`;

export const IconCustom = styled('div')`
  background-color: #0087c8;
  font-size: 10px;
  color: #f8f8f8;
  border-radius: 100%;
  padding: 4px;
  margin-right: 12px;
  width: 12px;
  height: 12px;
  margin-top: 2px;
`;

export const ClickHere = styled('span')`
  ${({ theme }) => `
    color:#2DBFF3;
    cursor:pointer;
    position:relative;
    &::before {
      content: "";
      position: absolute;
      cursor:pointer;
      width: 100px;
      height: 70px;
      left: -12px;
      top: -23px;
    }
    @media screen and (max-width: ${theme.breakpoint.sm}) {
    }
  `}
`;

export const ErrorDiv = styled.div`
  background-color: #ffffff;
  box-shadow: 0px 0px 4px #b11f42;
  padding: 24px;
  color: #b11f42;
  text-align: center;
  margin-top: 36px;
  font-size: 16px;
  @media screen and (max-width: ${({ props: { theme } }) => theme.breakpoint.sm}) {
    width: 250px;
    font-size: 14px;
    padding: 12px 20px;
    margin-top: 0px;
  }
`;

export const PageButton = styled('div')`
  ${({ theme }) => `
    border: 1px dashed #CECECE;
    border-radius: 8px;
    margin-bottom: ${theme.spacing.px15};
    padding-left:0;
    padding-top:0;
    padding-bottom:0;
    margin-left: auto;
    margin-right: auto;
    max-width: 326px;
    min-width:326px;
    min-height: 56px;
    text-align:center;
    display: flex;
    justify-content: center;
    color: #0087C8;
    font-size:16px;
    font-weight:bold;
    align-items: center;
    cursor: pointer;
    outline: none;
    box-sizing: border-box;
    @media screen and (max-width: ${theme.breakpoint.sm}) {
      min-width: 240px;
      width: 240px;
    }
  `}
`;

export const ModalContentWrapper = styled('div')`
  padding: 32px;
  color: #304e5c;
  font-size: 16px;
`;

export const PageSetWrapper = styled('div')`
  ${({ theme }) => `
    @media screen and (min-width: ${theme.breakpoint.sm}) {
      height:400px;
    }
  `}
`;
